module.exports = __webpack_public_path__ + "img/parallels.1c203029.jpg";